import { render, staticRenderFns } from "./UnitAmenityList.vue?vue&type=template&id=27bbfba6&scoped=true&"
import script from "./UnitAmenityList.vue?vue&type=script&lang=js&"
export * from "./UnitAmenityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bbfba6",
  null
  
)

export default component.exports